export const FILTER_NAVIGATION = 'filterNavigation';

export const FILTER_NAVIGATION_MUTATIONS = {
  setNavigationType: 'setNavigationType',
  setPendingTransfer: 'setPendingTransfer',
  clearPendingTransfer: 'clearPendingTransfer',
  setPageFilters: 'setPageFilters',
  pushRoute: 'pushRoute',
} as const;

export const FILTER_NAVIGATION_ACTIONS = {
  onNavigation: `${FILTER_NAVIGATION}/onNavigation`,
  setTransferFilters: `${FILTER_NAVIGATION}/setTransferFilters`,
  savePageFilters: `${FILTER_NAVIGATION}/savePageFilters`,
} as const;

export const FILTER_NAVIGATION_GETTERS = {
  getLastNavigationType: `${FILTER_NAVIGATION}/getLastNavigationType`,
  getPendingTransfer: `${FILTER_NAVIGATION}/getPendingTransfer`,
  getSavedFilters: `${FILTER_NAVIGATION}/getSavedFilters`,
  getRouteHistory: `${FILTER_NAVIGATION}/getRouteHistory`,
} as const;
